document.addEventListener('DOMContentLoaded', function() {
    // Seleccionar todos los tooltips con botones
    const tooltips = document.querySelectorAll('.video_and_image .tooltip');
    
    tooltips.forEach(tooltip => {
        const button = tooltip.querySelector('button');
        const tooltipText = tooltip.querySelector('.tooltip_txt');
        
        if (button && tooltipText && tooltip instanceof HTMLElement && button instanceof HTMLElement) {
            // Calcular el ancho disponible para el texto
            // Si el tooltip no es visible, temporalmente hacerlo visible para medir
            const wasHidden = tooltip.offsetWidth === 0;
            let originalDisplay = '';
            
            if (wasHidden) {
                originalDisplay = tooltip.style.display;
                tooltip.style.display = 'flex';
                tooltip.style.visibility = 'hidden';
            }
            
            const tooltipWidth = tooltip.offsetWidth;
            const buttonWidth = button.offsetWidth;
            
            // Restaurar estado original si estaba oculto
            if (wasHidden) {
                tooltip.style.display = originalDisplay;
                tooltip.style.visibility = '';
            }
            
            // Obtener el padding del CSS
            const computedStyle = window.getComputedStyle(tooltip);
            const paddingLeft = parseInt(computedStyle.paddingLeft) || 10;
            const paddingRight = parseInt(computedStyle.paddingRight) || 10;
            
            // Calcular el ancho disponible para el texto (sin gap porque lo removiste del CSS)
            const availableWidth = tooltipWidth - buttonWidth - paddingLeft - paddingRight - 10; // 10px para el espacio entre botón y texto
            
            // Guardar el ancho disponible como data attribute
            if (tooltipText instanceof HTMLElement) {
                tooltipText.dataset.textWidth = Math.max(availableWidth, 100) + 'px';
                
                // Inicializar estado abierto por defecto
                tooltip.classList.add('tooltip--open');
                tooltipText.style.width = tooltipText.dataset.textWidth;
            }
            
            // Agregar evento de click al botón
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Toggle del estado del tooltip
                if (tooltip.classList.contains('tooltip--open')) {
                    // Cerrar: ancho 0
                    tooltip.classList.remove('tooltip--open');
                    tooltip.classList.add('tooltip--closed');
                    if (tooltipText instanceof HTMLElement) {
                        tooltipText.style.width = '0px';
                    }
                } else {
                    // Abrir: usar el ancho calculado
                    tooltip.classList.remove('tooltip--closed');
                    tooltip.classList.add('tooltip--open');
                    if (tooltipText instanceof HTMLElement) {
                        tooltipText.style.width = tooltipText.dataset.textWidth || 'auto';
                    }
                }
            });
        }
    });
});
